<div id="block-daypilot">
  @if (daypilotInitialized) {
    <div id="block-top-left-corner">
      <rask-arbetsorder-planering-scheduler-settings
        [zoom]="zoom"
        [minZoom]="minZoom"
        [maxZoom]="maxZoom"
        [startDate]="startDate"
        [currentArbetsorder]="arbetsorder"
        (startDateChange)="startDateChange($event)"
        (zoomChange)="zoomChange($event)"
        (maskinlagChanged)="maskinlagChangedInSettings()"
        (scrollToArbetsorder)="focusOnArbetsorder()">
      </rask-arbetsorder-planering-scheduler-settings>
      <rask-planera-color-explanation-popover></rask-planera-color-explanation-popover>
    </div>
  }
  <daypilot-scheduler id="dp" [config]="schedulerConfig" [events]="schedulerEvents" #scheduler></daypilot-scheduler>
</div>
